// PLG Checkout messages
export const INSUFFICIENT_FUND = "insufficient funds";
export const ALREADY_AVAILED = "already availed a 7-day trial.";
export const ALREADY_SUBSCRIPTION = "already have a subscription to this plan";
